var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import ButtonMui from '@mui/material/Button';
import { forwardRef } from 'react';
export var Button = forwardRef(function (_a, ref) {
    var base = _a.base, children = _a.children, props = __rest(_a, ["base", "children"]);
    if (base) {
        return (_jsx("button", __assign({ ref: ref, style: {
                background: 'none',
                border: 'none',
                cursor: 'pointer',
            }, type: "button" }, props, { children: children })));
    }
    var extendedProps = props;
    return (_jsx(ButtonMui, __assign({ ref: ref }, extendedProps, { children: children })));
});
Button.displayName = 'Button';
